import { useState } from "react";
import { NavLink, Link } from "react-router-dom";
import { navLinks } from "../data/siteData";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header>
      <nav className="navbar">
        <Link className="logo" to="/">
          <img src="/assets/image/logo (3).png" alt="The Biswajit Nandi Studio" />
        </Link>

        <ul className={`nav-links ${open ? "active" : ""}`}>
          {navLinks.map((link) => (
            <li key={link.label}>
              <NavLink
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) => (isActive ? "is-active" : "")}
                onClick={() => setOpen(false)}
              >
                {link.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <Link className="btn" to="/contact">
          Lets talk
        </Link>

        <button
          type="button"
          className="menu-toggle"
          aria-label="Toggle menu"
          aria-expanded={open}
          onClick={() => setOpen((current) => !current)}
        >
          &#9776;
        </button>
      </nav>
    </header>
  );
}
